/**
 * Чем закончилось закрытие модального окна.
 * По типу кнопок на нем:
 * 1. `OK` - согласие, подтверждение
 * 2. `CANCEL` - Закрытие модальки без сохранения результатов редактирования объекта:
 *               по кнопкам "Нет", "Отмена", "Крестик" и тд.
 * 3. `SAVE` - сохранение результатов редактирования объекта в модальном окне
 *
 * !!! ВНИМАНИЕ!!!
 * Закрытие модальки по крестику приравнивается к отиене.
 */
export enum DxModalResultType {
  NONE = 'NONE',
  OK = 'OK',
  CANCEL = 'CANCEL',
  SAVE = 'SAVE'
}
